import React from "react";
import { useLocation } from "react-router-dom";
import CourseResultItem from "./course-result-item";
import NoResultPage from "components/thankyou/noresult-page";

const CoursesResult = () => {
  const location = useLocation();
  const { courses } = location.state || { courses: [] };

  return (
    <div className="courses-result">
      {courses.length ? (
        courses.map((course) => (
          <CourseResultItem
            course={course}
            key={course.id}
          />
        ))
      ) : (
        <NoResultPage
          text="Leider gibt es für deine Suchanfrage kein Ergebnisse!"
        />
      )}
    </div>
  );
};

export default CoursesResult;